import { useContext, createContext } from 'react';
import type { DragAndDropContextType } from '@app/services/aiFlow.types';

export const DragAndDropContext = createContext<DragAndDropContextType | undefined>(undefined);

export const useDragAndDrop = () => {
    const context = useContext(DragAndDropContext);
    if (!context) {
        throw new Error('useDnDNodes must be used within a DnDNodesProvider');
    }
    return context;
};
